export const noNewOrReviewCommentsExists = (contextState) => {
  if (!contextState) return false;

  const {
    incidentSummaryState,
    RootCauseState,
    PreventiveAndCorrectiveMeasuresState,
  } = contextState;

  const len = (state, type) => state?.comments?.[type]?.length ?? 0;

  return (
    len(incidentSummaryState, "NEW") === 0 &&
    len(incidentSummaryState, "INREVIEW") === 0 &&
    len(RootCauseState, "NEW") === 0 &&
    len(RootCauseState, "INREVIEW") === 0 &&
    len(PreventiveAndCorrectiveMeasuresState, "NEW") === 0 &&
    len(PreventiveAndCorrectiveMeasuresState, "INREVIEW") === 0
  );
}